var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthIconRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#5065E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2793 2.25V7.23937L13.4964 9.12375L9.2793 2.25Z",
    fill: "white",
    fillOpacity: 0.602
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28012 2.25L5.0625 9.12375L9.28012 7.23937V2.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2793 12.3571V15.7472L13.4992 9.90906L9.2793 12.3571Z",
    fill: "white",
    fillOpacity: 0.602
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28012 15.7472V12.3565L5.0625 9.90906L9.28012 15.7472Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2793 11.5723L13.4964 9.12373L9.2793 7.24048V11.5723Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0625 9.12373L9.28012 11.5723V7.24048L5.0625 9.12373Z",
    fill: "white",
    fillOpacity: 0.602
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthIconRound);
export default __webpack_public_path__ + "static/media/ethIconRound.ee9673460895d6324b749b7d90d2fbc1.svg";
export { ForwardRef as ReactComponent };